module.exports = __webpack_public_path__ + "static/img/pico20.b42a127.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico20.png
// module id = y7+n
// module chunks = 0